import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
const BaseTag = /*#__PURE__*/React.forwardRef(function BaseTag({
  before,
  contentElement,
  after,
  testId,
  tagCss,
  ...other
}, ref) {
  return jsx("span", _extends({}, other, {
    ref: ref,
    css: tagCss,
    "data-testid": testId
  }), before, contentElement, after);
});
export default BaseTag;